// src/settings.mjs

/** 
 * Standardperioder i selectboks - index 0 overskrives med boksens overskrift
 * @type {readonly (PeriodDuration | null)[]} 
 */
export const PERIODS = Object.freeze([
  null,
  Object.freeze({ years: 3 }),
  Object.freeze({ years: 4, months: 6 }),
  Object.freeze({ years: 6 }),
  Object.freeze({ years: 8 }),
]);

/** 
 * Standardlængde for specialtilfælde
 * @type {{ readonly years: number }}
 */
export const SPECIAL_EXT = Object.freeze(
  { years: 3 }
);

/** 
 * Demoposter
 * @type {readonly RawDemoEntry[]} 
 */
export const DEMO_ENTRIES = Object.freeze([
  { date: '2010-05-01', selectIndex: 3, special: false },
  { date: '2012-01-01', selectIndex: 3, special: false },
  { date: '2015-02-01', selectIndex: 2, special: true },
  { date: '2020-03-01', selectIndex: 2, special: true },
]);

/**
 * Hardcode experimenter, der indsættes før experimenter fra URL
 * @type {readonly string[]}
 */
export const EXPERIMENTS = [
  'chart-radius:20',
];

/**
 * Palette from https://sashamaps.net/docs/resources/20-colors/
 * @type {string[]}
 */
export const PALETTE = [
  'rgba(230, 25, 75, 0.5)',
  'rgba(60, 180, 75, 0.5)',
  'rgba(255, 225, 25, 0.5)',
  'rgba(0, 130, 200, 0.5)',
  'rgba(245, 130, 48, 0.5)',
  'rgba(145, 30, 180, 0.5)',
  'rgba(70, 240, 240, 0.5)',
  'rgba(240, 50, 230, 0.5)',
  'rgba(210, 245, 60, 0.5)',
  'rgba(250, 190, 212, 0.5)',
  'rgba(0, 128, 128, 0.5)',
  'rgba(220, 190, 255, 0.5)',
  'rgba(170, 110, 40, 0.5)',
  'rgba(255, 250, 200, 0.5)',
  'rgba(128, 0, 0, 0.5)',
  'rgba(170, 255, 195, 0.5)',
  'rgba(128, 128, 0, 0.5)',
  'rgba(255, 215, 180, 0.5)',
  'rgba(0, 0, 128, 0.5)',
  'rgba(128, 128, 128, 0.5)'
];

/**
 * @type {{ readonly screen: number, hover: number, print: number }}
 */
export const ALPHA_COLOR = Object.freeze({
  screen: 0.5,
  hover: 0.8,
  print: 1.0
});